import { render, staticRenderFns } from "./daliyEdit.vue?vue&type=template&id=528293a8&scoped=true"
import script from "./daliyEdit.vue?vue&type=script&lang=js"
export * from "./daliyEdit.vue?vue&type=script&lang=js"
import style0 from "./daliyEdit.vue?vue&type=style&index=0&id=528293a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528293a8",
  null
  
)

export default component.exports